import { render, staticRenderFns } from "./AlertProject.vue?vue&type=template&id=00d78ce0&"
import script from "./AlertProject.vue?vue&type=script&lang=js&"
export * from "./AlertProject.vue?vue&type=script&lang=js&"
import style0 from "./AlertProject.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports